"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleOauth2Login = handleOauth2Login;
var _nprogress = _interopRequireDefault(require("nprogress"));
var _router = _interopRequireDefault(require("@/router"));
var _store = _interopRequireDefault(require("@/store"));
var _domUtil = require("@/utils/domUtil");
var _user = require("./api/crm/user");
var _app = require("./config/app");
var _wechat = require("./config/wechat");
var _userAgent = require("./utils/userAgent");
// progress bar

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

const allowList = ['message']; // no redirect allowList
const defaultRoutePath = '/';
_router.default.beforeEach(async (to, from, next) => {
  if (to.query.from === 'union-platform' && to.query.subSystemInfo) {
    const info = JSON.parse(decodeURIComponent(to.query.subSystemInfo));
    await _store.default.dispatch('LoginSuccess', info);
  }
  const meta = to.meta || _router.default.$avueRouter.meta || {};
  meta.title !== 'undefined' && (0, _domUtil.setDocumentTitle)(`${to.meta.title} - ${_domUtil.domTitle}`);
  if (!_store.default.getters.accessToken && !_store.default.getters.fromUrl && !['oauth', 'lose', 'login', 'UserPwdReset', 'message'].includes(to.name)) {
    if ((0, _userAgent.isQywx)()) {
      handleOauth2Login(to, from, next);
      return;
    }
    next({
      name: 'login'
    });
    return;
  }
  if (_store.default.getters.accessToken) {
    if (to.path === _store.default.state.loginPath) {
      next({
        path: defaultRoutePath
      });
    } else {
      next();
    }
  } else if (allowList.includes(to.name) || to.meta.auth === false) {
    // 在免登录名单，直接进入
    next();
  } else {
    _store.default.dispatch('ALogout', true);
  }
});
_router.default.afterEach(() => {
  _nprogress.default.done(); // finish progress bar
});

/**
 * 处理企业微信 oauth2 授权
 * 通过 state 判断是不是微信回调过来的页面，如果不是则跳转，是则登录
 * @typedef {import('vue-router').Route} Route
 * @param {Route} to
 * @param {Route} from
 * @param {import ('vue-router').NavigationGuard} next
 */
async function handleOauth2Login(to, from, next) {
  if (to.query.state !== _wechat.WX_APP_CONFIG.state) {
    const {
      corpid,
      agentid,
      state,
      scope
    } = _wechat.WX_APP_CONFIG;
    const redirectUri = window.location.origin;
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpid}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}&agentid=${agentid}#wechat_redirect`;
  } else if (to.query.code) {
    try {
      await _store.default.dispatch('GetTenantInfo');
      const res = await (0, _user.oauth2Login)({
        code: to.query.code,
        type: _app.APP_TYPE.WX
      });
      await _store.default.dispatch('LoginSuccess', res);
      if (to.path === '/') {
        next(_store.default.getters.firstMenuPath);
        return;
      }
      next();
    } catch {
      next({
        name: 'login'
      });
    }
  }
}